import { render, staticRenderFns } from "./NawiCustomData.vue?vue&type=template&id=a7485a44&"
import script from "./NawiCustomData.vue?vue&type=script&lang=js&"
export * from "./NawiCustomData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports